import axiosInstance from '../axios/axios-instance';
import { UserActivityType } from 'shared/enums/user-activity-type/user-activity-type.enums';

export const verisoul = {
  /**
   * Authenticate method to tie Verisoul session to a user.
   */
  async authenticateSession(userActivityType: UserActivityType, sessionId?: string): Promise<void> {
    await axiosInstance.post('/verisoul/authenticate', { sessionId, userActivityType });
  },
};
